import { useQuery } from '@tanstack/react-query'
import type { BudgetsResponse } from 'typings'
import { useFetch } from '../useFetch'
import { BudgetMapper } from './BudgetMapper'
import { BUDGET_URL } from './constants'

const ALLOCATION_ID_MOCK = 'allocation-id-mock'

export function useBudgets() {
  const { fetcherWrapper } = useFetch()

  const url = new URL(`${BUDGET_URL}`, window.location.origin)

  url.search = new URLSearchParams({
    page: '1',
    pagesize: '10',
  }).toString()

  function fetcher() {
    return fetcherWrapper(url)
      .then((r) => r.json())
      .then((data) =>
        data.items.map((item) =>
          BudgetMapper.fromAPI(item, { id: ALLOCATION_ID_MOCK })
        )
      )
  }

  return useQuery<BudgetsResponse>({ queryKey: ['budgets'], queryFn: fetcher })
}
